module.exports = __webpack_public_path__ + "img/down-angle.a8a8f178.svg";